import reducer from './reducers';

export { default as feedSearchOperations } from './operations';
export { default as feedSearchSelector } from './selectores';
export { default as feedSearchTypes } from './types';

export default reducer;
